import { postOrderService, postPriceService } from "../../services/userService";
import { showErrorMessage } from "../../services/httpService";
import { errorMessage } from "../../utils/message";
import { calcPrice, clearInitial } from "./user";
import {
  NEXT_FIRST_TAB,
  NEXT_SECOND_TAB,
  NEXT_THIRD_TAB,
  GET_ORDERS_DETAILS,
  RETURN_TAB
} from "../../utils/stringConsts";

export const nextFirstSection = (
  deliveryId,
  serviceId,
  cities,
  packSizePackages,
  packSizePacking,
  states,
  origin
) => {
  return async (dispatch) => {
    await dispatch({
      type: NEXT_FIRST_TAB,
      payload: {
        deliveryId,
        serviceId,
        cities,
        packSizePackages,
        packSizePacking,
        states,
        origin,
      },
    });
  };
};

export const nextSecondSection = (
  des,
  name,
  phone,
  postal,
  receiverAddress,
  nationalId
) => {
  return async (dispatch) => {
    await dispatch({
      type: NEXT_SECOND_TAB,
      payload: {
        des,
        name,
        phone,
        postal,
        receiverAddress,
        nationalId,
      },
    });
  };
};

export const nextThirdSection = (packes) => {
  return async (dispatch) => {
    await dispatch({
      type: NEXT_THIRD_TAB,
      payload: { packes },
    });
  };
};

export const returnSection = () => {
  return async (dispatch) => {
    await dispatch({ type: RETURN_TAB });
  };
};

export const postPrice =
  (
    serviceType,
    deliveryType,
    destination,
    packages,
    packing,
    assu,
    pickup,
    origin,
    serviceFee,
    deliveryTypeId,
    serviceTypeId,
    token
  ) =>
    async (dispatch) => {
      const result = await postPriceService(
        serviceType, deliveryType, destination,
        packages, packing, assu, pickup, origin,
        serviceFee, deliveryTypeId, serviceTypeId, token
      );
      if (result.error) {
        switch (result.errorType) {
          case "request":
            errorMessage("خطای دسترسی به اینترنت");

            break;
          case "response":
            errorMessage(result.errorBody.data.message);

            break;

          default:
            errorMessage(result.errorBody.data.message);

            break;
        }
        // dispatch(userLoginFailure());
      } else {
        dispatch(calcPrice(result.data, packing, assu, pickup));
      }
    };

export const postOrder =
  (
    originLat,
    originLng,
    serviceTypeId,
    deliveryTypeId,
    destination,
    packages,
    packing,
    assurance,
    fullName,
    phoneNumber,
    address,
    postalCode,
    paymentTimeId,
    paymentTypeId,
    serviceFee,
    price,
    origin,
    pickup,
    nationalId,
    token
  ) =>
    async (dispatch) => {
      const result = await postOrderService(
        originLat,
        originLng,
        serviceTypeId,
        deliveryTypeId,
        Number(destination),
        packages,
        packing,
        assurance,
        fullName,
        phoneNumber,
        address,
        postalCode,
        paymentTimeId,
        paymentTypeId,
        serviceFee,
        price,
        origin,
        pickup,
        nationalId,
        token
      );
      if (result.error) {
        showErrorMessage(result);
      } else {
        dispatch(clearInitial(result.data));
        return { status: true, data: result.data };
      }
    };

export const getOrdersDetails = ({
  assurance,
  deliveryType,
  destination,
  origin,
  packages,
  packing,
  paymentStat,
  paymentTime,
  paymentType,
  price,
  recepientAddress,
  recepientName,
  recepientPhoneNumber,
  recepientPostalCode,
  senderAddress,
  senderName,
  senderPhoneNumber,
  serviceFee,
  serviceType,
  status,
  statusId,
  theDate,
  theTime,
  trackingNumber,
}) => {
  return async (dispatch) => {
    await dispatch({
      type: GET_ORDERS_DETAILS,
      payload: {
        assurance,
        deliveryType,
        destination,
        origin,
        packages,
        packing,
        paymentStat,
        paymentTime,
        paymentType,
        price,
        recepientAddress,
        recepientName,
        recepientPhoneNumber,
        recepientPostalCode,
        senderAddress,
        senderName,
        senderPhoneNumber,
        serviceFee,
        serviceType,
        status,
        statusId,
        theDate,
        theTime,
        trackingNumber,
      },
    });
  };
};
